import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  root: {
    height: "100%"
  },
  towerWrapper: {
    borderRadius: "32px"
  },
  first: {
    borderRadius: "32px 0 0 32px"
  },
  mid: {},
  last: {
    backgroundColor: theme.kooee.itemsTab.primary,
    borderRadius: "0px 32px 32px 0"
  },
  only: {
    backgroundColor: theme.kooee.itemsTab.primary,
    borderRadius: theme.spacing(4)
  },
  grid: {
    backgroundColor: theme.kooee.itemsTab.default,
    borderRadius: theme.spacing(4)
  },
  panelImageWrapper: {
    padding: "0.4em 0em",
    "&> svg": {
      fill: "#fff",
      height: "2em"
    },
    "&> img": {
      height: "2em"
    }
  },
  solar: {
    backgroundColor: theme.kooee.itemsTab.other,
    width: "54%"
  },
  battery: {
    backgroundColor: theme.kooee.itemsTab.secondary,
    width: "16%"
  },
  imageWrapper: {
    "&> svg": {
      height: "4em"
    }
  },
  section: {
    marginBottom: theme.spacing(4)
  },
  batteryWithSolar: {
    backgroundColor: theme.kooee.itemsTab.secondary,
    width: "25%"
  },
  reduWIdth: {
    width: "21%",
    "& > div > img": {
      width: "3.5em"
    }
  }
}));
